/**
 * TanStack Query hooks for `detail-drawer-over-row`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	detailDrawerOverRowQueryKeys,
	type CreateDetailDrawerOverRowBody,
	type ListDetailDrawerOverRowResponse,
	type DetailDrawerOverRowRow,
} from "./api";

export function useDetailDrawerOverRowList(): UseQueryResult<ListDetailDrawerOverRowResponse, Error> {
	return useQuery({
		queryKey: detailDrawerOverRowQueryKeys.list(),
		queryFn: list,
	});
}

export function useDetailDrawerOverRowCreate(): UseMutationResult<DetailDrawerOverRowRow, Error, CreateDetailDrawerOverRowBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: detailDrawerOverRowQueryKeys.all });
		},
	});
}

export function useDetailDrawerOverRowDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: detailDrawerOverRowQueryKeys.all });
		},
	});
}
